import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-user-training-plan',
  templateUrl: './user-training-plan.component.html',
  styleUrls: ['./user-training-plan.component.scss']
})
export class UserTrainingPlanComponent implements OnInit {
  
  ngOnInit(): void {
  }

}
